<p-dialog (visibleChange)="close()" [modal]="true" [style]="{ width: (this.remBySize() + 'rem') }" [visible]="visible()"
          header="{{title()}}">
  @if (headerTemplate()) {
    <ng-template #header>
      <ng-container *ngTemplateOutlet="headerTemplate()!"/>
    </ng-template>
  }
  <div class="py-2">
    <ng-content></ng-content>
  </div>
  <br>
  <div class="flex justify-end gap-2">
    @if (mustDisplayCancelButton()) {
      <elcia-button (onClick)="this.close()" [label]="'action.cancel' | translate" [severity]="'secondary'"/>
    }
    @if (this.mustDisplayDeleteButton()) {

      <elcia-button (onClick)="this.delete()" [icon]="'delete'" [label]="'action.delete' | translate"
                    [severity]="'danger'"/>
    }
    @if (this.mustDisplayActionButton()) {
      <elcia-button (onClick)="this.action()"
                    [disabled]="isActionLoading()"
                    [icon]="this.actionIcon()"
                    [label]="this.actionLabel() | translate"
                    data-testid="dialog-action"/>
    }
  </div>
</p-dialog>

